import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import PhotoAlbum from './PhotoAlbum';

const PhotoAlbumPage = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const photoAlbumRef = React.useRef();
  
  const handlePhotoUpload = (e) => {
    if (photoAlbumRef.current) {
      photoAlbumRef.current.handlePhotoUpload(e);
    }
  };

  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-bold text-gray-900">Photo Gallery</h1>
        </div>
        <div className="mb-6 flex justify-between items-center">
          <button
            onClick={() => navigate('/')}
            className="bg-[#04b53a] text-white px-4 py-2 rounded hover:bg-[#039431] transition-colors"
          >
            Return to Cards
          </button>
          <input
            type="file"
            accept="image/*"
            onChange={handlePhotoUpload}
            className="hidden"
            id="photo-upload"
          />
          <label
            htmlFor="photo-upload"
            className="cursor-pointer bg-[#04b53a] text-white px-4 py-2 rounded hover:bg-[#039431] transition-colors"
          >
            Add Photos
          </label>
        </div>
        <PhotoAlbum 
          ref={photoAlbumRef}
          user={currentUser} 
          hideHeader={true}
          hideUpload={true}
        />
      </div>
    </div>
  );
};

export default PhotoAlbumPage; 